import { userLoginApi } from '@/api/index';
import { useUserStore } from '@/store/userStore';

// 用于防止top50页面重复记录的标志
let top50RecordPending = false;

/**
 * 记录用户访问页面
 * @param {Object} to - 当前路由对象
 * @param {Object} from - 上一个路由对象（可选）
 * @returns {Promise}
 */
export async function trackPageView(to, from = null) {
  try {
    // 获取用户ID
    const userStore = useUserStore();
    const userId = userStore.userId;
    
    if (!userId) {
      console.log('[访问记录] 未登录，跳过记录');
      return;
    }

    // 获取sub_id
    const subId = getSubId(to);
    
    // 特殊处理top50页面:如果sub_id为空,说明group_id还没有添加,等待300ms后会有group_id
    if (to.name === 'top50PortfolioDetail' && !subId) {
      if (!top50RecordPending) {
        top50RecordPending = true;
      }
      return;
    }
    
    // 如果是top50页面且有sub_id,清除pending标志
    if (to.name === 'top50PortfolioDetail' && subId && top50RecordPending) {
      top50RecordPending = false;
    }

    // 构造访问记录数据
    const viewData = {
      user_id: userId,
      route: to.name || '',  // 路由名称
      sub_id: subId,  // 子ID（如公司代码、组合ID等）
      page_url: to.fullPath,  // 完整URL路径
      refer: from ? from.fullPath : '',  // 上一个页面地址
      fav_type: getFavType(to),  // 根据路由判断类型
      page_name: to.meta?.title || '',  // 页面中文名称
    };

    // 调用接口记录
    await userLoginApi.insertViewRecord(viewData);
  } catch (error) {
    // 静默失败，不影响用户体验
    console.error('[访问记录] 记录失败:', error);
  }
}

/**
 * 获取sub_id
 * @param {Object} route 
 * @returns {string} sub_id值
 */
function getSubId(route) {
  // top50页面特殊处理：使用query中的group_id
  if (route.name === 'top50PortfolioDetail') {
    return route.query.group_id || '';
  }
  
  // portfolioDetail页面：优先使用路由参数id，其次使用query中的group_id
  if (route.name === 'portfolioDetail') {
    return route.params.id || route.query.group_id || '';
  }
  
  // 其他页面：按优先级获取
  // 优先级: id > code > comp_exch > query.id
  return route.params.id || route.params.code || route.params.comp_exch || route.query.id || '';
}

/**
 * 根据路由判断收藏类型
 * @param {Object} route 
 * @returns {number} 1-票池，2-公司，3-页面
 */
function getFavType(route) {
  const routeName = route.name;
  
  // 公司详情相关
  if (routeName === 'companyDetail') {
    return 2;
  }
  
  // 股票池相关
  if (
    routeName === 'corePool' || 
    routeName === 'stocksGroup' || 
    routeName === 'portfolioDetail' ||
    routeName === 'top50PortfolioDetail'
  ) {
    return 1;
  }
  
  // 默认为页面
  return 3;
}

/**
 * 获取需要排除记录的路由列表
 * @returns {Array<string>}
 */
export function getExcludedRoutes() {
  return [
    'login',  // 登录页
    'home',   // 首页（可选）
  ];
}
